import { useSelector } from 'react-redux';
import { userSelector } from 'modules/taboola-common-frontend-modules/authentication';

export const ActiveUserCaption = () => {
    const user = useSelector(userSelector);

    return <span>{user.full_name}</span>;
};
